var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkyPurplePink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 248,
    viewBox: "0 0 165 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H165L112.5 248H0V0Z",
    fill: "url(#paint0_linear_5638_66788)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1453 61.8855C55.3579 65.3969 53.1139 68.6031 46.6967 68.6794H32.6814C32.2483 68.6794 31.9334 68.2977 32.0121 67.8779L33.0357 63.374C33.1144 63.0687 33.39 62.8397 33.705 62.8397H46.6967C48.7833 62.8397 49.3738 62.3817 49.5707 61.6565C49.7282 61.0076 49.4919 60.3969 47.8384 59.7481L41.1063 57.0763C38.5474 56.1221 35.0435 54.1374 36.0277 49.8244C36.8151 46.4275 39.2954 43.2214 45.5157 43.1832H58.5862C59.0192 43.1832 59.3342 43.5649 59.2555 43.9847L58.2319 48.4885C58.1531 48.7939 57.8775 49.0229 57.5626 49.0229H44.9251C43.2323 49.0229 42.7598 49.5573 42.6811 50.1298C42.563 50.7405 43.2716 51.2366 45.0432 52L51.1848 54.4809C54.295 55.7405 57.1295 57.458 56.1453 61.8855ZM71.3417 32H66.0663C65.7513 32 65.4758 32.229 65.397 32.5344L57.4445 67.8779C57.3657 68.2977 57.6807 68.6794 58.1138 68.6794H63.3892C63.7041 68.6794 63.9797 68.4504 64.0585 68.145L72.011 32.7634C72.0897 32.3817 71.7748 32 71.3417 32ZM110.081 43.2214H104.097C103.9 43.2214 103.703 43.2977 103.585 43.4504L93.9396 54.0229L87.483 43.5649C87.3649 43.374 87.1287 43.2595 86.8925 43.2595H84.5697H81.0659H78.5856C78.3888 43.2595 78.1919 43.3359 78.0738 43.4885L66.8537 55.7405L74.6487 68.374C74.7668 68.5649 75.0031 68.6794 75.2393 68.6794H81.4596C81.9714 68.6794 82.3257 68.1069 82.0501 67.687L74.6881 55.7405L82.3651 47.2672L90.042 59.7481L86.3413 76.1985C86.2626 76.6183 86.5775 77 87.0106 77H92.0892C92.4042 77 92.6797 76.771 92.7585 76.4656L96.5379 59.7099L110.593 44.2901C110.947 43.8702 110.671 43.2214 110.081 43.2214Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5638_66788",
    x1: -13,
    y1: 10,
    x2: 110,
    y2: 226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD7A5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA53A5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkyPurplePink);
export default __webpack_public_path__ + "static/media/sky-purple-pink.ac2e271bb4724b9347b64a83238fbee3.svg";
export { ForwardRef as ReactComponent };